<script>
   export let day = "";
   export let numberOfDay = "";
   export let month = "";
   export let year;
</script>

<h3>{day} {numberOfDay} {month} {year}</h3>

